document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

class PaulissenMenu extends HTMLElement {
  connectedCallback() {
    this.addEventListener('toggle', (event) => {
      const opened = event.target;
      if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;
      this.querySelectorAll('details[open]').forEach((details) => {
        if (details !== opened && !details.contains(opened)) details.removeAttribute('open');
      });
    }, true);
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        this.querySelectorAll('details[open]').forEach((details) => details.removeAttribute('open'));
      }
    });
  }
}
if (!customElements.get('paulissen-menu')) customElements.define('paulissen-menu', PaulissenMenu);

/**
 * Verwijdert extern ingeladen WhatsApp-widgets.
 * Paulissen Witgoed gebruikt geen WhatsApp-nummer op de storefront.
 */
(() => {
  const whatsappSelector = [
    'a[href*="wa.me" i]',
    'a[href*="api.whatsapp.com" i]',
    'a[href*="whatsapp.com/send" i]',
    'iframe[src*="whatsapp" i]',
    '[id*="whatsapp" i]',
    '[class*="whatsapp" i]',
    '[aria-label*="whatsapp" i]',
    '[title*="whatsapp" i]',
    '[data-testid*="whatsapp" i]',
    '[data-widget*="whatsapp" i]'
  ].join(',');

  const addImmediateHideRules = () => {
    if (document.getElementById('pw-block-foreign-whatsapp')) return;
    const style = document.createElement('style');
    style.id = 'pw-block-foreign-whatsapp';
    style.textContent = `${whatsappSelector}{display:none!important;visibility:hidden!important;pointer-events:none!important}`;
    (document.head || document.documentElement).appendChild(style);
  };

  const removeWidget = (match) => {
    if (!(match instanceof Element) || !match.isConnected) return;

    let target = match.closest(
      '[id*="whatsapp" i], [class*="whatsapp" i], [data-testid*="whatsapp" i], [data-widget*="whatsapp" i]'
    ) || match;

    if (target === match) {
      let ancestor = match.parentElement;
      for (let depth = 0; ancestor && depth < 6; depth += 1, ancestor = ancestor.parentElement) {
        const style = window.getComputedStyle(ancestor);
        const rect = ancestor.getBoundingClientRect();
        const compactFloatingWidget = (
          (style.position === 'fixed' || style.position === 'sticky')
          && rect.width <= 520
          && rect.height <= 760
        );
        if (compactFloatingWidget) {
          target = ancestor;
          break;
        }
      }
    }

    target.remove();
  };

  const cleanWhatsApp = (root = document) => {
    if (!(root instanceof Document || root instanceof Element || root instanceof DocumentFragment)) return;
    if (root instanceof Element && root.matches(whatsappSelector)) removeWidget(root);
    root.querySelectorAll(whatsappSelector).forEach(removeWidget);
  };

  addImmediateHideRules();

  const start = () => {
    cleanWhatsApp(document);
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) cleanWhatsApp(node);
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
